import { isSlideNodes } from "@custom-types/slide-nodes-type-guards";
import { DownloadUtils } from "@stellar/utils";

/**
 * Downloads and returns the slide nodes from the passed download URL
 *
 * @returns An array of slide nodes
 * @throws {error} if it fails to download the slide nodes
 */
export async function downloadSlideNodes(slideNodesUrl) {
  try {
    // Download the raw data (Blob object), get it in JSON string and parse it.
    const blob = await DownloadUtils.downloadFilePromise(slideNodesUrl);
    const dataString = await blob.text();
    const data = JSON.parse(dataString);
    if (!isSlideNodes(data)) {
      throw new Error("The download slide nodes object does not have the expected type");
    }
    return data.slideNodes;
  } catch {
    return [];
  }
}